module.exports = __webpack_public_path__ + "img/18.83e0215d.jpg";